<template>
  <div style="width: 100%">
    <mx-panel v-if="!IsDelete && value" :type="config.Type" :value="value" :config="Config" panel="SystemList2" :selected="selected" :index="index" @event="OnEvent">
      <template>
        <div class="flex-row" style="width: 100%">
          <div class="wf left" style="color: #878a99">名称</div>

          <div class="wf left" style="color: #878a99">考试状态</div>
          <div class="wf left" style="color: #878a99">考试结果</div>
          <div class="wf left" style="color: #878a99">考试分数</div>
          <div class="wf left" style="color: #878a99">开始答题时间</div>
          <div class="wf left" style="color: #878a99">结束答题时间</div>
          <div class="wf left" style="color: #878a99">创建时间</div>
          <div class="wf left" style="color: #878a99">操作</div>
        </div>
      </template>
      <template slot="content">
        <div class="flex-row start middle border-bottom" style="width: 100%; padding: 20px 0">
          <div class="wf flex-row start list active" v-if="value.Parent">
            {{ value.Parent.Name }}
          </div>
          <div class="wf flex-row start list">
            <mx-field :value="value" :config="ExamStateField" :type="ExamStateField.Type" :name="ExamStateField.Name" v-if="ExamStateField"> </mx-field>
          </div>
          <div class="wf flex-row start list">
            <mx-field :value="value" :config="ExamResultField" :type="ExamResultField.Type" :name="ExamResultField.Name" v-if="ExamResultField"> </mx-field>
          </div>
          <div class="wf flex-row start list">
            {{ value.ExamScore }}
          </div>
          <div class="wf flex-row start list">
            {{ ExamStartTime }}
          </div>
          <div class="wf flex-row start list">
            {{ ExamEndTime }}
          </div>
          <div class="wf flex-row start list">
            {{ value.CreateTime }}
          </div>
          <div class="wf flex-row start list">
            <div class="pointer active" @click="onExportDoc">导出培训档案</div>
            <div class="pointer active" @click="onGoDetail" v-if="IsDetail">详情</div>
          </div>
        </div>
      </template>
      <div slot="button"></div>
    </mx-panel>

    <mx-element type="Dialog" theme="Pop" :config="DialogConfig" :key="key" title="学员培训明细" v-if="dialogVisible" :value="dialogVisible ? 1 : 0">
      <mx-page type="Home" theme="panel" :config="PageConfig" :value="value" name="学员培训明细" title="学员培训明细" :parent="value" :parent-type="config.Type" :key="key" />
    </mx-element>
  </div>
</template>

<script>
import { jsPDF as JsPDF } from 'jspdf'
import html2Canvas from 'html2canvas'
import base from 'matrix.node.ui/libs/panels/base.js'
export default {
  props: {
    config: Object,
    value: Object,
    index: Number,
    role: String,
    roleField: String,
    name: String,
    selected: Object
  },
  mixins: [base],
  data() {
    return { IsModify: false, IsDelete: false, dialogVisible: false, key: new Date().getTime() }
  },
  computed: {
    SiteUrl() {
      return this.$matrix.Config.ImageSite
    },
    Config() {
      return Object.assign({ EventName: this.name ? this.name : 'TypeEvent', IsDark: false }, this.config)
    },
    IsDetail() {
      if (this.config.DetailView) return true
      return false
    },
    ExamStartTime() {
      return this.value.ExamStartTime.indexOf('1970') > -1 ? '-' : this.value.ExamStartTime
    },
    ExamEndTime() {
      return this.value.ExamEndTime.indexOf('1970') > -1 ? '-' : this.value.ExamEndTime
    },
    ExamStateField() {
      return this.$matrix.Models[this.config.Type].Fields.find((val) => {
        return val.Name === 'ExamState'
      })
    },
    ExamResultField() {
      return this.$matrix.Models[this.config.Type].Fields.find((val) => {
        return val.Name === 'ExamResult'
      })
    },
    DialogConfig() {
      return {
        Width: '1200px',
        OnClose: () => {
          this.dialogVisible = false
        }
      }
    },
    PageConfig() {
      return {
        Role: this.config.Role,
        RoleField: this.config.RoleField
      }
    }
  },
  methods: {
    OnEvent(e) {
      this.$emit('event', e)
    },
    onGoDetail() {
      let View = this.config.DetailView
      if (!View) return this.$matrix.ShowError('未配置详情视图')
      this.$emit('goview', {
        View: View,
        ViewType: '详情',
        Data: this.value,
        Role: this.config.Role,
        RoleField: this.config.RoleField
      })
    },
    onExportDoc() {
      this.key = new Date().getTime()
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped>
.wf {
  flex: 1;
}

.wf2 {
  flex: 2;
}

.border {
  border: 1px solid #eee;
}

.label_1,
.label_2,
.label_3 {
  border-radius: 4px;
  padding: 4px 6px;
  text-align: center;
}

.label_1 {
  background: #fbc451;

  color: #fff;
}

.label_2 {
  background: #a498cb;

  color: #fff;
}

.label_3 {
  background: #a7bba9;

  color: #fff;
}

.label_4 {
  background: #f49a71;

  color: #fff;
}

.label_5 {
  background: #6d72bb;

  color: #fff;
}

.active {
  color: #2d8cf0;
}

.text-line {
  text-decoration: line-through;
  color: gray;
}

span.button {
  color: #2d8cf0;
  cursor: pointer;
}

.image-box {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  opacity: 1;
  background-color: rgba(243, 246, 249, 1);
  padding: 4px;
}

.border-bottom {
  border-bottom: 1px solid #e9ebec;
}
</style>

